import { app } from '../../../../app';
import { Controller } from './directory-manage.controller';

app.component('companyDirectoryIntegrationManage', {
    bindings: {
        directory: '<',
        companyId: '<',
        directories: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/directory-manage.component.js